import { Deal, SongSummary } from '~/features/dashboard/store/models';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { NewUser, User } from '~/store/user/models';
import { MusicListItemDto, SongSummaryListDto } from '~/models/music/music.dto';
import { MoneyListItemDto } from '~/models/contract.dto';
import { DealRegionListResponse, NewDealResponseDto } from '~/models/deals/new-deal/NewDealResponse.dto';
import { DealResponse } from '~/models/deals';
import { NewSongResponseDto, songTagsFields } from '~/models/music/new-song/newSongResponse.dto';
import { DealTypeListResponse, DealFormatListResponse, DealCodeListResponse } from '~/models/deals/new-deal/NewDealResponse.dto';
import { contactCodeListResponse } from '~/models/team/TeamCodeList.dto';
import { DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { DealSubTypeList } from '~/models/deals/DealSubTypeList.dto';
import { DealDocumentDto, DealDocumentTypeDto } from '~/models/deals/DealDocument.dto';
import { UserProfile } from '~/models/profile/UserProfile.dto';
import { SongListings } from '~/models/music/SongListings.dto';
import {AKAsList} from "~/models/contacts.dto";

enum DASHBOARD_ACTION_TYPE {
    CREATE_CONTACT_REQUEST = '@dashboard/CREATE_CONTACT_REQUEST',
    CREATE_CONTACT_SUCCESS = '@dashboard/CREATE_CONTACT_SUCCESS',
    CREATE_CONTACT_FAILURE = '@dashboard/CREATE_CONTACT_FAILURE',

    GET_CONTACTS_REQUEST = '@dashboard/GET_CONTACTS_REQUEST',
    GET_CONTACTS_SUCCESS = '@dashboard/GET_CONTACTS_SUCCESS',
    GET_CONTACTS_FAILURE = '@dashboard/GET_CONTACTS_FAILURE',

    GET_DEALS_REQUEST = '@dashboard/GET_DEALS_REQUEST',
    GET_DEALS_SUCCESS = '@dashboard/GET_DEALS_SUCCESS',
    GET_DEALS_FAILURE = '@dashboard/GET_DEALS_FAILURE',

    GET_DEALSUMMARY_REQUEST = '@dashboard/GET_DEALSUMMARY_REQUEST',
    GET_DEALSUMMARY_SUCCESS = '@dashboard/GET_DEALSUMMARY_SUCCESS',
    GET_DEALSUMMARY_FAILURE = '@dashboard/GET_DEALSUMMARY_FAILURE',
    GET_DEAL_SONGS_SUMMARY_REQUEST = '@dashboard/GET_DEAL_SONGS_SUMMARY_REQUEST',
    GET_DEAL_SONGS_SUMMARY_SUCCESS = '@dashboard/GET_DEAL_SONGS_SUMMARY_SUCCESS',
    GET_DEAL_SONGS_SUMMARY_FAILURE = '@dashboard/GET_DEAL_SONGS_SUMMARY_FAILURE',

    GET_DEAL_DETAILS_REQUEST = '@dashboard/GET_DEAL_DETAILS_REQUEST',
    GET_DEAL_DETAILS_SUCCESS = '@dashboard/GET_DEAL_DETAILS_SUCCESS',
    GET_DEAL_DETAILS_FAILURE = '@dashboard/GET_DEAL_DETAILS_FAILURE',

    GET_DEAL_SUB_DEALS_SUMMARY_REQUEST = '@dashboard/GET_DEAL_SUB_DEALS_SUMMARY_REQUEST',
    GET_DEAL_SUB_DEALS_SUMMARY_SUCCESS = '@dashboard/GET_DEAL_SUB_DEALS_SUMMARY_SUCCESS',
    GET_DEAL_SUB_DEALS_SUMMARY_FAILURE = '@dashboard/GET_DEAL_SUB_DEALS_SUMMARY_FAILURE',

    GET_DEAL_DOCUMENTS_REQUEST = '@dashboard/GET_DEAL_DOCUMENTS_REQUEST',
    GET_DEAL_DOCUMENTS_SUCCESS = '@dashboard/GET_DEAL_DOCUMENTS_SUCCESS',
    GET_DEAL_DOCUMENTS_FAILURE = '@dashboard/GET_DEAL_DOCUMENTS_FAILURE',

    GET_DEAL_DOCUMENT_TYPES_REQUEST = '@dashboard/GET_DEAL_DOCUMENT_TYPES_REQUEST',
    GET_DEAL_DOCUMENT_TYPES_SUCCESS = '@dashboard/GET_DEAL_DOCUMENT_TYPES_SUCCESS',
    GET_DEAL_DOCUMENT_TYPES_FAILURE = '@dashboard/GET_DEAL_DOCUMENT_TYPES_FAILURE',

    CREATE_NEW_DEAL_STAGE_REQUEST = '@dashboard/CREATE_NEW_DEAL_STAGE_REQUEST',
    CREATE_NEW_DEAL_STAGE_SUCCESS = '@dashboard/CREATE_NEW_DEAL_STAGE_SUCCESS',
    CREATE_NEW_DEAL_STAGE_FAILURE = '@dashboard/CREATE_NEW_DEAL_STAGE_FAILURE',

    CREATE_SONG_TAGS_REQUEST = '@dashboard/CREATE_SONG_TAGS_REQUEST',
    CREATE_SONG_TAGS_SUCCESS = '@dashboard/CREATE_SONG_TAGS_SUCCESS',
    CREATE_SONG_TAGS_FAILURE = '@dashboard/CREATE_SONG_TAGS_FAILURE',

    RESET_NEW_DEAL_FORM = '@dashboard/RESET_NEW_DEAL_FORM',
    EDIT_DEAL_FORM = '@dashboard/EDIT_DEAL_FORM',
    EDIT_SONG_FORM = '@@dashboard/EDIT_SONG_FORM',
    NEW_DEAL_FORM_PREV_STEP = '@dashboard/NEW_DEAL_FORM_PREV_STEP',
    NEW_DEAL_FORM_NEXT_STEP = '@dashboard/NEW_DEAL_FORM_NEXT_STEP',
    SET_DEAL_FORM_STEP = '@SET_DEAL_FORM_STEP',

    GET_COUNTRY_LIST = '@dashboard/GET_COUNTRY_LIST',

    CREATE_NEW_SONG_STAGE_REQUEST = '@dashboard/CREATE_NEW_SONG_STAGE_REQUEST',
    CREATE_NEW_SONG_STAGE_SUCCESS = '@dashboard/CREATE_NEW_SONG_STAGE_SUCCESS',
    CREATE_NEW_SONG_STAGE_FAILURE = '@dashboard/CREATE_NEW_SONG_STAGE_FAILURE',

    RESET_NEW_SONG_FORM = '@dashboard/RESET_NEW_SONG_FORM',
    NEW_SONG_FORM_PREV_STEP = '@dashboard/NEW_SONG_FORM_PREV_STEP',
    NEW_SONG_FORM_NEXT_STEP = '@dashboard/NEW_SONG_FORM_NEXT_STEP',
    NEW_SONG_FORM_GO_TO_STEP = '@dashboard/NEW_SONG_FORM_GO_TO_STEP',

    GET_MUSICS_REQUEST = '@dashboard/GET_MUSICS_REQUEST',
    GET_MUSICS_SUCCESS = '@dashboard/GET_MUSICS_SUCCESS',
    GET_MUSICS_UPDATE = '@dashboard/GET_MUSICS_UPDATE',
    GET_MUSICS_FAILURE = '@dashboard/GET_MUSICS_FAILURE',

    //Song SUmmary List
    GET_SONGSUMMARY_REQUEST = '@dashboard/GET_SONGSUMMARY_REQUEST',
    GET_SONGSUMMARY_SUCCESS = '@dashboard/GET_SONGSUMMARY_SUCCESS',
    GET_SONGSUMMARY_FAILURE = '@dashboard/GET_SONGSUMMARY_FAILURE',
    GET_SONG_DEAL_SUMMARY_REQUEST = '@dashboard/GET_SONG_DEAL_SUMMARY_REQUEST',
    GET_SONG_DEAL_SUMMARY_SUCCESS = '@dashboard/GET_SONG_DEAL_SUMMARY_SUCCESS',
    GET_SONG_DEAL_SUMMARY_FAILURE = '@dashboard/GET_SONG_DEAL_SUMMARY_FAILURE',

    GET_CONTRACTS_REQUEST = '@dashboard/GET_CONTRACTS_REQUEST',
    GET_CONTRACTS_SUCCESS = '@dashboard/GET_CONTRACTS_SUCCESS',
    GET_CONTRACTS_FAILURE = '@dashboard/GET_CONTRACTS_FAILURE',

    TOGGLE_NAW_DRAWER = '@dashboard/TOGGLE_NAW_DRAWER',
    GET_DEAL_TYPE_LIST__REQUEST = '@dashboard/GET_DEAL_TYPE_LIST__REQUEST',
    GET_DEAL_TYPE_LIST_SUCCESS = '@dashboar/GET_DEAL_TYPE_LIST_SUCCESS',
    GET_DEAL_TYPE_LIST_FAILURE = '@dashboard/GET_DEAL_TYPE_LIST_FAILURE',

    //Search filter deal
    GET_DEAL_SEARCH_FILTER_REQUEST = '@dashboard/GET_DEAL_SEARCH_FILTER_REQUEST',
    GET_DEAL_SEARCH_FILTER_SUCCESS = '@dashboar/GET_DEAL_SEARCH_FILTER_SUCCESS',
    GET_DEAL_SEARCH_FILTER_FAILURE = '@dashboard/GET_DEAL_SEARCH_FILTER_FAILURE',

    GET_MONEY_SEARCH_FILTER_REQUEST = '@dashboard/GET_MONEY_SEARCH_FILTER_REQUEST',
    GET_MONEY_SEARCH_FILTER_SUCCESS = '@dashboar/GET_MONEY_SEARCH_FILTER_REQUEST',
    GET_MONEY_SEARCH_FILTER_FAILURE = '@dashboard/GET_MONEY_SEARCH_FILTER_REQUEST',

    GET_SONG_SEARCH_FILTER_REQUEST = '@dashboard/GET_SONG_SEARCH_FILTER_REQUEST',
    GET_SONG_SEARCH_FILTER_SUCCESS = '@dashboar/GET_SONG_SEARCH_FILTER_SUCCESS',
    GET_SONG_SEARCH_FILTER_FAILURE = '@dashboard/GET_SONG_SEARCH_FILTER_FAILURE',

    GET_TEAM_SEARCH_FILTER_REQUEST = '@dashboard/GET_TEAM_SEARCH_FILTER_REQUEST',
    GET_TEAM_SEARCH_FILTER_SUCCESS = '@dashboar/GET_TEAM_SEARCH_FILTER_SUCCESS',
    GET_TEAM_SEARCH_FILTER_FAILURE = '@dashboard/GET_TEAM_SEARCH_FILTER_FAILURE',

    GET_DEAL_FORMAT_LIST__REQUEST = '@dashboard/GET_DEAL_FORMAT_LIST__REQUEST',
    GET_DEAL_FORMAT_LIST_SUCCESS = '@dashboar/GET_DEAL_FORMAT_LIST_SUCCESS',
    GET_DEAL_FORMAT_LIST_FAILURE = '@dashboard/GET_DEAL_FORMAT_LIST_FAILURE',

    GET_DEAL_CODE_LIST__REQUEST = '@dashboard/GET_DEAL_CODE_LIST__REQUEST',
    GET_DEAL_CODE_LIST_SUCCESS = '@dashboar/GET_DEAL_CODE_LIST_SUCCESS',
    GET_DEAL_CODE_LIST_FAILURE = '@dashboard/GET_DEAL_CODE_LIST_FAILURE',

    GET_DEAL_REGION_LIST__REQUEST = '@dashboard/GET_DEAL_REGION_LIST__REQUEST',
    GET_DEAL_REGION_LIST_SUCCESS = '@dashboar/GET_DEAL_REGION_LIST_SUCCESS',
    GET_DEAL_REGION_LIST_FAILURE = '@dashboard/GET_DEAL_REGION_LIST_FAILURE',

    GET_CONTACT_TYPE_LIST__REQUEST = '@dashboard/GET_CONTACT_TYPE_LIST__REQUEST',
    GET_CONTACT_TYPE_LIST_SUCCESS = '@dashboar/GET_CONTACT_TYPE_LIST_SUCCESS',
    GET_CONTACT_TYPE_LIST_FAILURE = '@dashboard/GET_CONTACT_TYPE_LIST_FAILURE',

    IS_SONG_FORM_EDITING = '@dashboard/IS_SONG_FORM_EDITING',

    IS_DEAL_FORM_EDITING = '@dashboard/IS_DEAL_FORM_EDITING',

    RESET_NEW_CONTACT_FORM = '@dashboard/RESET_NEW_CONTACT_FORM',

    DETECT_SONG_CHANGE = '@dashboard/DETECT_SONG_CHANGE',

    LINK_ALL_SONGS = '@dashboard/LINK_ALL_SONGS',

    GET_USER_PROFILE__REQUEST = '@dashboard/GET_USER_PROFILE__REQUEST',
    GET_USER_PROFILE_SUCCESS = '@dashboar/GET_USER_PROFILE_SUCCESS',
    GET_USER_PROFILE_FAILURE = '@dashboard/GET_USER_PROFILE_FAILURE',

    GET_SONG_LISTINGS_LIST__REQUEST = '@dashboard/GET_SONG_LISTINGS_LIST__REQUEST',
    GET_SONG_LISTINGS_LIST_SUCCESS = '@dashboar/GET_SONG_LISTINGS_LIST_SUCCESS',
    GET_SONG_LISTINGS_LIST_FAILURE = '@dashboard/GET_SONG_LISTINGS_LIST_FAILURE',

    RESET_AKAS_LISTINGS_LIST = '@dashboard/RESET_AKAS_LISTINGS_LIST',

    GET_SOUND_LISTINGS_LIST__REQUEST = '@dashboard/GET_SOUND_LISTINGS_LIST__REQUEST',
    GET_SOUND_LISTINGS_LIST_SUCCESS = '@dashboar/GET_SOUND_LISTINGS_LIST_SUCCESS',
    GET_SOUND_LISTINGS_LIST_FAILURE = '@dashboard/GET_SOUND_LISTINGS_LIST_FAILURE',

    GET_ARTWORK_LISTINGS_LIST__REQUEST = '@dashboard/GET_ARTWORK_LISTINGS_LIST__REQUEST',
    GET_ARTWORK_LISTINGS_LIST_SUCCESS = '@dashboar/GET_ARTWORK_LISTINGS_LIST_SUCCESS',
    GET_ARTWORK_LISTINGS_LIST_FAILURE = '@dashboard/GET_ARTWORK_LISTINGS_LIST_FAILURE',

    UPDATE_DEFAULT_REQUEST = '@dashboard/UPDATE_DEFAULT_REQUEST',
    UPDATE_DEFAULT_SUCCESS = '@dashboard/UPDATE_DEFAULT_SUCCESS',
    UPDATE_DEFAULT_FAILURE = '@dashboard/UPDATE_DEFAULT_FAILURE',

    GET_AKAs_REQUEST = '@dashboard/GET_AKAs_REQUEST',
    GET_AKAs_SUCCESS = '@dashboard/GET_AKAs_SUCCESS',
    GET_AKAs_FAILURE = '@dashboard/GET_AKAs_FAILURE',
}

export const createNewDealStageActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.CREATE_NEW_DEAL_STAGE_REQUEST,
    DASHBOARD_ACTION_TYPE.CREATE_NEW_DEAL_STAGE_SUCCESS,
    DASHBOARD_ACTION_TYPE.CREATE_NEW_DEAL_STAGE_FAILURE
)<undefined, NewDealResponseDto, { error: Error }>();

export const resetNewContactForm = createAction(DASHBOARD_ACTION_TYPE.RESET_NEW_CONTACT_FORM)();

export const editNewDealForm = createAction(DASHBOARD_ACTION_TYPE.EDIT_DEAL_FORM)<{ step: number }>();

export const editNewSongForm = createAction(DASHBOARD_ACTION_TYPE.EDIT_SONG_FORM)<{ step: number }>();
export const countryListForm = createAction(DASHBOARD_ACTION_TYPE.GET_COUNTRY_LIST)<{ countryCodeList: [] }>();
export const editNewSongToStepForm = createAction(DASHBOARD_ACTION_TYPE.EDIT_SONG_FORM)<{ step: number }>();
export const resetNewDealForm = createAction(DASHBOARD_ACTION_TYPE.RESET_NEW_DEAL_FORM)();
export const newDealFormPrevStep = createAction(DASHBOARD_ACTION_TYPE.NEW_DEAL_FORM_PREV_STEP)();
export const newDealFormNextStep = createAction(DASHBOARD_ACTION_TYPE.NEW_DEAL_FORM_NEXT_STEP)();
export const setDealFormStep = createAction(DASHBOARD_ACTION_TYPE.SET_DEAL_FORM_STEP)();

export const isSongFormEditing = createAction(DASHBOARD_ACTION_TYPE.IS_SONG_FORM_EDITING)<boolean>();
export const isDealFormEditing = createAction(DASHBOARD_ACTION_TYPE.IS_DEAL_FORM_EDITING)<boolean>();

export const createNewSongStageActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.CREATE_NEW_SONG_STAGE_REQUEST,
    DASHBOARD_ACTION_TYPE.CREATE_NEW_SONG_STAGE_SUCCESS,
    DASHBOARD_ACTION_TYPE.CREATE_NEW_SONG_STAGE_FAILURE
)<undefined, NewSongResponseDto, { error: Error }>();

export const createSongTags = createAsyncAction(
    DASHBOARD_ACTION_TYPE.CREATE_SONG_TAGS_REQUEST,
    DASHBOARD_ACTION_TYPE.CREATE_SONG_TAGS_SUCCESS,
    DASHBOARD_ACTION_TYPE.CREATE_SONG_TAGS_FAILURE
)<undefined, songTagsFields, { error: Error }>();

export const resetNewSongForm = createAction(DASHBOARD_ACTION_TYPE.RESET_NEW_SONG_FORM)();
export const newSongFormPrevStep = createAction(DASHBOARD_ACTION_TYPE.NEW_SONG_FORM_PREV_STEP)();
export const newSongFormNextStep = createAction(DASHBOARD_ACTION_TYPE.NEW_SONG_FORM_NEXT_STEP)();
export const newSongFormGoToStep = createAction(DASHBOARD_ACTION_TYPE.NEW_SONG_FORM_GO_TO_STEP)<{ step: number }>();
export const detectSongChange = createAction(DASHBOARD_ACTION_TYPE.DETECT_SONG_CHANGE)<{ value: boolean }>();
export const setlinkAllSong = createAction(DASHBOARD_ACTION_TYPE.LINK_ALL_SONGS)<{ value: boolean }>();

export const getSongSummaryDealActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_SONGSUMMARY_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_SONGSUMMARY_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_SONGSUMMARY_FAILURE
)<{ creatorId: number; assetCode: string }, SongSummaryListDto[], { error: Error }>();

export const createContactActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.CREATE_CONTACT_REQUEST,
    DASHBOARD_ACTION_TYPE.CREATE_CONTACT_SUCCESS,
    DASHBOARD_ACTION_TYPE.CREATE_CONTACT_FAILURE
)<NewUser, User, { error: Error }>();

export const getContactsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_CONTACTS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_CONTACTS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_CONTACTS_FAILURE
)<{ creatorId: number }, User, { error: Error }>();

export const getDealSummaryActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEALSUMMARY_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEALSUMMARY_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEALSUMMARY_FAILURE
)<{ creatorId: number }, { deals: DealSummaryListDto[] }, { error: Error }>();

export const getDealsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEALS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEALS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEALS_FAILURE
)<{ creatorId: number }, { deals: Deal[]; dealsResponse: DealResponse[] }, { error: Error }>();

export const getDealSubDealsSummaryActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_SUB_DEALS_SUMMARY_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SUB_DEALS_SUMMARY_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SUB_DEALS_SUMMARY_FAILURE
)<{ creatorId: number; assetCode: string }, { dealSubDeals: DealSummaryListDto[] }, { error: Error }>();

export const getDealDocumentsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENTS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENTS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENTS_FAILURE
)<{ assetCode: string }, { dealDocuments: DealDocumentDto[] }, { error: Error }>();

export const getDealDocumentTypesActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENT_TYPES_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENT_TYPES_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DOCUMENT_TYPES_FAILURE
)<void, { dealDocumentTypes: DealDocumentTypeDto[] }, { error: Error }>();

export const getDealSongsSummaryActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_SONGS_SUMMARY_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SONGS_SUMMARY_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SONGS_SUMMARY_FAILURE
)<{ creatorId: number; assetCode: string }, { songs: SongSummary[] }, { error: Error }>();

export const getSearchDealFilterActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_SEARCH_FILTER_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SEARCH_FILTER_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_SEARCH_FILTER_FAILURE
)<{ searchValue: string }, { searchDealFilter: string }, { error: Error }>();

export const getSearchSongFilterActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_SONG_SEARCH_FILTER_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_SONG_SEARCH_FILTER_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_SONG_SEARCH_FILTER_FAILURE
)<{ searchValue: string }, { searchSongFilter: string }, { error: Error }>();

export const getSearchTeamFilterActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_TEAM_SEARCH_FILTER_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_TEAM_SEARCH_FILTER_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_TEAM_SEARCH_FILTER_FAILURE
)<{ searchValue: string }, { searchTeamFilter: string }, { error: Error }>();

export const getSearchMoneyFilterActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_MONEY_SEARCH_FILTER_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_MONEY_SEARCH_FILTER_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_MONEY_SEARCH_FILTER_FAILURE
)<{ searchValue: string }, { searchMoneyFilter: string }, { error: Error }>();

export const getDealDetailsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_DETAILS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DETAILS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_DETAILS_FAILURE
)<{ assetCode: string; projectId: any }, { deals: Deal[]; dealsResponse: DealResponse[], dealSubTypeList: DealSubTypeList }, { error: Error }>();

export const getMusicsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_MUSICS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_MUSICS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_MUSICS_UPDATE,
    DASHBOARD_ACTION_TYPE.GET_MUSICS_FAILURE
)<{ creatorId: number }, MusicListItemDto[], { error: Error }>();

export const getSongDealsSummaryActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_SONG_DEAL_SUMMARY_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_SONG_DEAL_SUMMARY_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_SONG_DEAL_SUMMARY_FAILURE
)<{ creatorId: number }, MusicListItemDto[], { error: Error }>();

export const getContractsActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_CONTRACTS_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_CONTRACTS_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_CONTRACTS_FAILURE
)<{ creatorId: number }, MoneyListItemDto[], { error: Error }>();

export const toggleNawDrawerAction = createAction(DASHBOARD_ACTION_TYPE.TOGGLE_NAW_DRAWER)<boolean | void>();

export const getDealTypesList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_TYPE_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_TYPE_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_TYPE_LIST_FAILURE
)<undefined, DealTypeListResponse[], { error: Error }>();

export const getDealFormatsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_FORMAT_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_FORMAT_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_FORMAT_LIST_FAILURE
)<undefined, DealFormatListResponse[], { error: Error }>();

export const getDealCodesList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_CODE_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_CODE_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_CODE_LIST_FAILURE
)<undefined, DealCodeListResponse[], { error: Error }>();

export const getDealRegionsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_DEAL_REGION_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_DEAL_REGION_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_DEAL_REGION_LIST_FAILURE
)<undefined, DealRegionListResponse[], { error: Error }>();

export const getContactTypesList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_CONTACT_TYPE_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_CONTACT_TYPE_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_CONTACT_TYPE_LIST_FAILURE
)<undefined, contactCodeListResponse[], { error: Error }>();

export const getUserProfileTypes = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_USER_PROFILE__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_USER_PROFILE_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_USER_PROFILE_FAILURE
)<undefined, UserProfile, { error: Error }>();

export const updateDefaultActions = createAsyncAction(
    DASHBOARD_ACTION_TYPE.UPDATE_DEFAULT_REQUEST,
    DASHBOARD_ACTION_TYPE.UPDATE_DEFAULT_SUCCESS,
    DASHBOARD_ACTION_TYPE.UPDATE_DEFAULT_FAILURE
)<undefined, UserProfile, { error: Error }>();

export const getSongListingsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_SONG_LISTINGS_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_SONG_LISTINGS_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_SONG_LISTINGS_LIST_FAILURE
)<undefined, SongListings[], { error: Error }>();

export const getSoundListingsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_SOUND_LISTINGS_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_SOUND_LISTINGS_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_SOUND_LISTINGS_LIST_FAILURE
)<undefined, SongListings[], { error: Error }>();

export const getArtworkListingsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_ARTWORK_LISTINGS_LIST__REQUEST,
    DASHBOARD_ACTION_TYPE.GET_ARTWORK_LISTINGS_LIST_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_ARTWORK_LISTINGS_LIST_FAILURE
)<undefined, SongListings[], { error: Error }>();

export const getAKAsListingsList = createAsyncAction(
    DASHBOARD_ACTION_TYPE.GET_AKAs_REQUEST,
    DASHBOARD_ACTION_TYPE.GET_AKAs_SUCCESS,
    DASHBOARD_ACTION_TYPE.GET_AKAs_FAILURE
)<undefined, AKAsList[], { error: Error }>();

export const resetAKAsListingsList = createAction(DASHBOARD_ACTION_TYPE.RESET_AKAS_LISTINGS_LIST)();